/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import {
	animate,
	style,
	transition,
	trigger
} from "@angular/animations";
import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input
} from "@angular/core";
import { PopoverModule } from "../floating/popover/popover.module";
import { UserAvatarComponent } from "../user-avatar/user-avatar.component";

@Component({
	selector: "cb-users-avatar-list",

	imports: [CommonModule, UserAvatarComponent, PopoverModule],
	templateUrl: "./users-avatar-list.component.html",
	styleUrl: "./users-avatar-list.component.scss",
	animations: [
		trigger("userAnimation", [
			transition(":enter", [
				style({ transform: "scale(0.3)", opacity: 0 }),
				animate(
					"300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)",
					style({ transform: "scale(1)", opacity: 1 }),
				),
			]),
			transition(":leave", [
				style({ transform: "scale(1)", opacity: 1 }),
				animate(
					"300ms cubic-bezier(0.8, -0.8, 0.2, 1)",
					style({ transform: "scale(0.3)", opacity: 0 }),
				),
			]),
		]),
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersAvatarListComponent {
	public usersIds = input.required<string[]>();
	public maxUsers = input<number>(3);
	public size = input<"xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl">("md");
	public hasPopover = input<boolean>(true);
	public onlyAvatar = input<boolean>(true);
	
	public filteredUsersIds = computed(() => {
		const withoutDuplicates = [...new Set(this.usersIds())];
		return withoutDuplicates.slice(0, this.maxUsers());
	});

	public avatarsList = input<
		{
			id: string;
			name: string;
			profile_img: string;
			avatar_type: string;
			custom_initials: string;
		}[]
	>([]);

	public enableAnimation = input<boolean>(false);
}
